import React from 'react';
import {
    DeleteRegular,
    ArchiveRegular,
    PinRegular,
    FlagRegular,
    MailRegular,
    MailReadRegular,
    SubtractCircleRegular,
} from '@fluentui/react-icons';

const ICON_COMPONENT_MAP: Record<
    string,
    React.ComponentType<{
        className?: string;
        style?: React.CSSProperties;
    }>
> = {
    DeleteRegular,
    ArchiveRegular,
    PinRegular,
    FlagRegular,
    MailRegular,
    MailReadRegular,
    SubtractCircleRegular,
};

export interface IconComponentProps {
    iconName: string;
    className?: string;
    style?: React.CSSProperties;
}

/**
 * Renders a Fluent v9 icon component based on the icon name string.
 * Used for dynamic icon rendering in swipe actions.
 */
export const IconComponent: React.FC<IconComponentProps> = ({ iconName, className, style }) => {
    const Icon = ICON_COMPONENT_MAP[iconName];

    if (!Icon) {
        return null;
    }

    return <Icon className={className} style={style} />;
};
